import { NavigationLgMd } from './NavigationLgMd';
import { NavigationXs } from './NavigationXs';
import type { NavigationProps } from './types';
import { useIsAgendaEnabledInEvent } from '../../displayHelpers';
import { useRingSettings } from '@bizzabo/entities';

const Navigation: React.FC<NavigationProps> = ({ isDesktop, event, goToHomePage, ...props }) => {
    const isAgendaEnabledInEvent = useIsAgendaEnabledInEvent(event?.uniqueName);
    const { data: ringSettings } = useRingSettings(event?.id, event?.accountId, {
        enabled: !!event,
        retry: 1,
    });
    const logoUrl = ringSettings?.customization?.customLogoSource ?? event.headerLogoUrl;
    return isDesktop ? (
        <NavigationLgMd
            goToHomePage={goToHomePage}
            eventHeaderLogoUrl={logoUrl}
            eventName={event.name}
            eventId={event.id}
            shouldShowAgenda={isAgendaEnabledInEvent}
            {...props}
        />
    ) : (
        <NavigationXs
            eventHeaderLogoUrl={logoUrl}
            eventName={event.name}
            eventId={event.id}
            {...props}
        />
    );
};

export default Navigation;
